import {
    disposable, dispose, shouldDispose
} from "./dispose.ts";

import {
    getTargetId, setGetHook, subscribe,
    type GetEvent
} from "./observable.ts";

import {
    debounce, evalFactor, type Factor
} from "./utils.ts";


/** Follow changing values */
export const follow = (
    func : () => void, 
    delay = 0
) => {
    const events : GetEvent[] = [];

    const hook = (
        event : GetEvent
    ) => {
        if(!events.some(e => getTargetId(e.proxy) === getTargetId(event.proxy) && e.prop === event.prop)) {
            events.push(event);
            subscribe(event.proxy, event.prop, compute);
        }
    }

    const followObj = Symbol("follow");
    shouldDispose(() => dispose(followObj, func));

    let compute = debounce(() => disposable(followObj, () => {
        try {
            setGetHook(hook);
            func();
        } finally {
            setGetHook();
        }
    }), delay)

    compute();
}
